/**
 * Every reading is paid at its start (2026-10-29, Chris: "just let them click
 * through and see the summary without needing to reveal"). There is no Reveal
 * in the panel; the draw takes the price (backend reader/service/
 * reading_charge) and its conversation reply says so in `reading_charge`:
 *   { is_paid, charged, reason, price_carats, carat_balance }
 * or, when the reading could not start (short of carats), { short: <402 body> }.
 */

/** The reply's `reading_charge`, normalised; null when there is none. */
export function readingChargeOf(reply) {
  const rc = reply && reply.reading_charge
  if (!rc || typeof rc !== 'object') return null
  if (rc.short) return { short: rc.short }
  return {
    isPaid: rc.is_paid === true,
    charged: Number(rc.charged) || 0,
    reason: rc.reason || '',
    balance: typeof rc.carat_balance === 'number' ? rc.carat_balance : null,
  }
}

/**
 * Put the store right: a charge marks the reading paid and takes the server's
 * balance; a short reply changes nothing but a balance it states (the words
 * body before the Community opens carries none). Returns { short }.
 */
export function applyReadingCharge(store, rc) {
  if (!store || !rc) return { short: false }
  if (rc.short) {
    if (typeof rc.short.carat_balance === 'number') store.querent_carat_balance = rc.short.carat_balance
    return { short: true }
  }
  if (rc.isPaid) store.latest_reading_session_is_paid = true
  if (rc.balance !== null && rc.balance !== undefined) store.querent_carat_balance = rc.balance
  return { short: false }
}
